import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';
import snackbar from './snackbar';
import auth from './auth';
import modal from './modal';
import pageFilters from './page-filters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    layout,
    snackbar,
    modal,
    pageFilters
  },
});
